'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import IconPicker from 'ContentComponents/cmv2/fields/IconPicker';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { getHasDismissedIconSetWarning } from 'DesignData/selectors/app';
import { dismissIconSetWarning } from 'DesignData/actions/Application';
import { ICON } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT, ICON_SET } from 'DesignData/enums/CustomWidgetFieldAttributes';
import UISelect from 'UIComponents/input/UISelect';
import UILink from 'UIComponents/link/UILink';
import UIAlert from 'UIComponents/alert/UIAlert';
import ToolFieldset from 'DesignComponents/tool/ToolFieldset';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import { ICON_SETS, DEFAULT_ICON_SET } from 'ContentUtils/constants/IconSets';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

const ICON_SET_OPTIONS = Object.keys(ICON_SETS).filter(set => set !== ICON_SETS['fontawesome-5']).map(set => {
  return {
    text: set,
    value: set
  };
});

class IconContentOptions extends PureComponent {
  constructor(props) {
    super(props);

    this.onDefaultChange = icon => {
      this.props.editField({
        [DEFAULT]: icon
      });
    };

    this.onSetChange = ({
      target: {
        value
      }
    }) => {
      this.props.editField({
        [ICON_SET]: value
      });
    };

    this.onIconSetWarningClose = () => {
      this.setState({
        showIconSetWarning: false
      });
      this.props.dismissIconSetWarning();
    };

    const iconSet = props.field && props.field[ICON_SET];
    this.state = {
      showIconSetWarning: iconSet !== DEFAULT_ICON_SET
    };
  }

  componentDidUpdate(prevProps) {
    const {
      field
    } = this.props;
    const {
      field: prevField
    } = prevProps;
    const iconSet = field && field[ICON_SET];
    const prevIconSet = prevField && prevField[ICON_SET];

    if (prevIconSet !== iconSet) {
      this.setState({
        showIconSetWarning: iconSet !== DEFAULT_ICON_SET
      });
    }
  }

  render() {
    const {
      field,
      hasDismissedIconSetWarning,
      readOnly
    } = this.props;
    let iconSet = field[ICON_SET] || DEFAULT_ICON_SET;

    if (iconSet === ICON_SETS['fontawesome-5']) {
      iconSet = ICON_SETS['fontawesome-5.0.10'];
    }

    const showIconSetWarning = this.state.showIconSetWarning && !hasDismissedIconSetWarning;
    return /*#__PURE__*/_jsxs(ToolFieldset, {
      children: [/*#__PURE__*/_jsx(IconPicker, {
        icon_set: iconSet,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`defaultLabels.${ICON}`)
        }),
        onFieldChange: this.onDefaultChange,
        value: field[DEFAULT],
        readOnly: readOnly
      }), /*#__PURE__*/_jsx(ToolFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('icon.set.label')
        }),
        tooltip: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: i18nKey('icon.set.tooltip'),
          options: {
            changelogLink: /*#__PURE__*/_jsx(UILink, {
              external: true,
              href: "https://fontawesome.com/changelog/latest",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('icon.set.changelogLink')
              })
            })
          }
        }),
        children: /*#__PURE__*/_jsx(UISelect, {
          onChange: this.onSetChange,
          options: ICON_SET_OPTIONS,
          value: iconSet
        })
      }), showIconSetWarning && /*#__PURE__*/_jsx(UIAlert, {
        className: "m-top-2",
        type: "warning",
        closeable: true,
        onClose: this.onIconSetWarningClose,
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: i18nKey('icon.iconSetWarning'),
          options: {
            iconSetProperty: /*#__PURE__*/_jsx("code", {
              children: "icon_set"
            })
          }
        })
      })]
    });
  }

}

IconContentOptions.propTypes = {
  dismissIconSetWarning: PropTypes.func.isRequired,
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  hasDismissedIconSetWarning: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    hasDismissedIconSetWarning: getHasDismissedIconSetWarning(state)
  };
}

const mapDispatchToProps = {
  dismissIconSetWarning
};
export default connect(mapStateToProps, mapDispatchToProps)(IconContentOptions);